<template>
    <div class="centerPage">
        <div class="search flex">
            <span class="tit">系统通知</span>
        </div>
        <div class="border">
            <el-table v-if="data.length!==0"
                      :data="data"
                      @expand-change="read"
                      style="width: 100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline>
                            <el-form-item label="详情">
                                <div class="narrate" v-html="props.row.content" style="white-space: pre-line;"></div>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column label="消息标题" prop="title">
                </el-table-column>
                <el-table-column label="消息时间" prop="createDate">
                </el-table-column>
                <el-table-column
                        align="right"
                        label="是否已读"
                        prop="isRead">
                    <template slot-scope="props">
                        <el-tag v-if="props.row.isRead===1" type="success">已读</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <div class="empty" v-else>
                <img src="../../assets/img/no.png" alt="" width="200">
                <p>这里什么都没有</p>
            </div>
            <el-pagination
                    class="pagination"
                    background
                    prev-text="Prev"
                    next-text="Next"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.current"
                    :page-size="page.size"
                    layout="prev, pager, next"
                    :total="page.total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import { mapMutations} from 'vuex';
    import common from "../../api/common";
    export default {
        name: "doctorMessage",
        data() {
            return {
                page: {
                    current: 1,
                    size: 9,
                    total: 0
                },//关于分页
                data: [],
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            ...mapMutations(['setMessage']),
            handleSizeChange(val) {
                this.page.size = val;
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getData();
            },
            getData() {
                let that = this;
                this.$ajax
                    .get(common.api.message.system.page.replace("{current}/{size}",this.page.current+"/"+this.page.size))
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.data = res.data.rows;
                        that.page.total = res.data.total;
                      }
                    })
            },
            read(row) {
                if (row.isRead === 0) {
                    let that = this;
                    this.$ajax
                        .post(common.api.message.system.read.replace("{id}",row.id))
                        .then(function (res) {
                          if (res.data.status === 'success') {
                            row.isRead = 1
                            // that.getData();
                            that.countNotRead()
                          } else {
                            that.$message.error(res.data.message);
                          }
                        }).catch((err) => {
                      console.error(err);
                      that.$message.error('操作失败');
                    })
                }
            },
            countNotRead() {
                let that = this;
                this.$ajax.get(common.api.message.system.countNotRead)
                    .then(function (res) {
                        // that.countNotReadMessage = res.data.data
                        that.setMessage(res.data.data)
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/patients.scss';

    .blue {
        color: #567BFF;
    }

    .search div:first-child {
        width: 50%;
    }

    .orange {
        font-size: 13px;
        color: #FC7B66;
        margin-left: 5%;
    }

    .detail {
        border-color: #567BFF;
        color: #567BFF;
        background: #ffffff;

        &:hover, &:focus {
            color: #567BFF;
            border-color: #567BFF;
            background-color: #ffffff;
        }
    }
</style>